import type { AddressInterface } from '@valk-nx/core/lib/interfaces/hotels.interface';

export class GpsDirectionHelper {
	private static readonly BASE_URL = 'https://www.google.com/maps/dir/?api=1';
	private static readonly TRAVELMODE = 'driving';

	static getDirectionUrl(
		destination: Partial<AddressInterface>,
	): string | null {
		const destinationParam = this.buildDestinationParam(destination);

		if (!destinationParam) {
			return null;
		}

		return `${this.BASE_URL}&destination=${destinationParam.replaceAll(' ', '%20')}&travelmode=${this.TRAVELMODE}`;
	}

	private static buildDestinationParam(
		destination: Partial<AddressInterface>,
	): string | null {
		if (
			destination.latitude !== undefined &&
			destination.longitude !== undefined
		) {
			return `${destination.latitude},${destination.longitude}`;
		}

		const streetParts = [
			destination.street,
			destination.streetNumber,
			destination.streetNumberAddition,
		]
			.filter(Boolean)
			.join('+');

		if (!streetParts && !destination.postalCode && !destination.city) {
			return null;
		}

		return `${streetParts},${destination.postalCode ?? ''}+${destination.city ?? ''}`;
	}
}
